<template>
  <div v-loading="loading">
    <iframe
        ref="mainIframe"
        :src="`${$bigDataUrl}/#/iframeLogin?token=${mainToken}&isIframe=${isIframe}&url=${url}`"
        width="100%"
        :style="{'height': documentClientHeight-100 + 'px'}"
        frameborder="0"
        scrolling="yes"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      loading: true,
      mainToken:'', // token
      isIframe:true, // 标识
      url:'exportAnalysis-exportOneDetail', // 要跳转的指定路由位置(传name即可)
  }
  },
  computed: {
    // 获取高度，解决iframe高度固定150的问题
    documentClientHeight: {
      get () { return this.$store.state.common.documentClientHeight },
      set (val) { this.$store.commit('common/updateDocumentClientHeight', val) }
    },
  },
  created() {
    this.mainToken = this.$cookie.get('access_token');

  },
  mounted() {
    const iframe = this.$refs.mainIframe;
    // IE和非IE浏览器，监听iframe加载事件不一样，需要兼容
    if (iframe.attachEvent) { // IE
      iframe.attachEvent('onload', () => { this.loading = false; });
    } else { // 非IE
      iframe.onload =  () => { this.loading = false; };
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
